import { render, staticRenderFns } from "./ItemNavigation.vue?vue&type=template&id=b1834f92&"
import script from "./ItemNavigation.vue?vue&type=script&lang=ts&"
export * from "./ItemNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1834f92')) {
      api.createRecord('b1834f92', component.options)
    } else {
      api.reload('b1834f92', component.options)
    }
    module.hot.accept("./ItemNavigation.vue?vue&type=template&id=b1834f92&", function () {
      api.rerender('b1834f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemNavigation.vue"
export default component.exports